import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import type { TWHeightProp } from '@fragment/ui/src/types/tailwind';

export const GradientOverflow = <HeightProp,>({
  height = 'h-f6' as TWHeightProp<HeightProp>,
  bodyRef,
}: {
  height?: TWHeightProp<HeightProp>;
  // this is a ref to the main component of the page / scroll area you want to monitor
  // for responsive disappearing
  bodyRef?: React.RefObject<HTMLDivElement>;
}) => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    if (!bodyRef) return;
    const body = bodyRef.current;
    if (!body) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = body;
      const isBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
      setIsAtBottom(isBottom);
    };

    body.addEventListener('scroll', handleScroll);
    // eslint-disable-next-line consistent-return
    return () => body.removeEventListener('scroll', handleScroll);
  }, [bodyRef]);
  return (
    <div
      className={clsx(
        'absolute inset-x-0 bottom-0 bg-gradient-to-t from-canvas pointer-events-none transition-opacity duration-100',
        height,
        isAtBottom ? 'opacity-0' : 'opacity-100'
      )}
    />
  );
};
